import React from 'react';
import { Stack } from 'react-bootstrap';
import { RequestFormSelector } from './components/RequestFormSelector';
import { RequestFormFragment } from '../../../__generated__/graphql';

type StepSelectRequestFormProps = {
  requestForms: ReadonlyArray<
    Pick<RequestFormFragment, 'Id' | 'Name' | 'flair__Information__c'>
  >;
  onSubmit: (requestFormId: string) => void;
  onCancel: () => void;
  selectedFormId: string | null;
  onFormSelect: (formId: string | null) => void;
};

export const StepSelectRequestForm: React.FC<StepSelectRequestFormProps> = ({
  requestForms,
  selectedFormId,
  onFormSelect,
}) => {
  return (
    <Stack gap={3}>
      <RequestFormSelector
        requestForms={requestForms}
        selectedFormId={selectedFormId}
        onFormSelect={onFormSelect}
      />
    </Stack>
  );
};
